const warehouse = {
  inventoryOrderList: '采购单入库',
  orderNumber: '订单编号',
  documentNumber: '单证编号',
  changeType: '变更类型',
  lot: '批次',
  quantity: '数量',
  totalIn: '总入库',
  totalOut: '总出库',
  inventory: '盘点',
  balance: '结余',
  plSelectProduct: "请选择商品",
  plProductNum: "请输入商品数量",
  productNumMin: "商品数量最少为{{ num }}",
  addProduct: "添加商品信息",
  addProductForm: "填写{{ name }}单",

  inbound: '入库',
  outbound: '出库',

  deliveryOrderNumber: '送货（入库）单号',
  materialRequisitionNumber: '领料（出库）单号',

  inboundOprt: '我要入库',
  outboundOprt: '我要出库',
  outboundError: '出库失败',
  outboundSuccess: '出库成功',
  insufficientInventory: '库存不足',
  forceOutbound: '是否强制出库？',
  forceOutboundFailed: '强制出库失败',
  inboundError: '入库失败',
  outboundNotEnough: '库存数量不足',
  returnStock: '退库',
  returnStockSuccess: '退库成功',
  returnStockFail: '退库失败',
  returnQuantity: '退库数量',
  selectLocationToReturn: '选择要退库的库位',
  selectLocationToInbound: '选择入库库位',
  available: '可用',
  returnExceedsAvailable: '退库数量超过可用数量',
  returnExceedsOriginal: '退库数量超过原单数量 {{original}}',
  validationError: '验证失败',
  sourcesPick: '领料',
  pickingOutbound: '领料出库',
  sourcesInReturn: '入库单退回',
  sourcesOutReturn: '出库单退回',

  numDetail: '录入数量详情',
  productNum: '商品数量',

  arrivalAt: '到货时间',
  remark: '备注',
  enterRemark: '请输入备注',
  requiredArrivalAt: '要求到货时间',
  actualArrivalAt: '实际到货时间',
  plArrivalAt: '请输入到货时间',
  startTime: '开始时间',
  endTime: '结束时间',
  deliveryStartTime: '送货开始时间',
  deliveryEndTime: '送货结束时间',
  plProduct: '请选择商品',
  inQuantity: '入库数量',
  plInQuantity: '请输入入库数量',
  outQuantity: '出库数量',
  plOutQuantity: '请输入出库数量',
  codeRepeat: '条码重复，请删除后再次操作',
  orderType: '入库单类型',
  inOrder: '入库单',
  preInOrder: '送货单入库（预入库）',
  purchaseOrder: '采购单',
  selectOrderType: '请选择入库单类型',
  selectOrderNumber: '请输入入库单号',
  numberNotExist: '单号不存在',
  orderConfirmed: '该订单已确认',
  purchaseNotPass: '采购未通过',
  saveOrder: '保存入库单',
  orderSuccess: '入库成功',
  code: '条码',
  existCode: '已存在',
  deleteBarcode: '确定删除条码？',
  deleteBarcodeSuccess: '删除成功',
  clearCode: '确定清空条码？',
  clear: '清空条码',
  existBarcode: '已录入条码:',
  outboundType: '出库类型',
  inboundType: '入库类型',
  preOutOrder: '领料单出库（预出库）',
  outSuccess: '出库成功',
  tempIn: '临时入库',
  tempOut: '临时出库',
  preIn: '预入库数量',
  preOut: '预出库数量',
  product: '商品',
  salesOrder: '销售单',
  outOrder: '出库单',
  specialOutbound: '专用料出库（需求清单）',
  exportExcel: '导出Excel',
  packingExportConfirm: '是否确认导出分拣单？',
  specialMaterialList: '专用料列表',
  specialOutSuccess: '专用料出库成功',
  specialOutFail: '专用料出库失败',
  normalMaterialList: '公共库列表',
  count: '库存数量',
  thirdPartyBatch: '供应商批次号',

  inOK: "入库成功",
  outOK: "出库成功",
  inFail: "入库失败",
  outFail: "出库失败",

  // 库存管理
  materialList: '物料列表',
  locationList: '库位列表',
  realMaterialList: '在库库存',
  locationCode: '库位编码',
  locationType: '库位类型',
  searchMaterialPlaceholder: '搜索物料编码/名称',
  searchLocationPlaceholder: '搜索库位编码',
  searchBatchPlaceholder: '搜索批次号/供应商批次号',
  searchMultiCodePlaceholder: '搜索存货编码（支持多个用空格分隔）',
  batchList: '批次列表',
  materialDetail: '物料明细',
  lotCount: '批次数量',
  locationDetail: '库位明细',
  barcodeList: '条码列表',
  state: '状态',
  lotItemLocationId: '批次库位ID',
  viewBarcode: '查看条码',
  batchNo: '批次号',
  deliveryBatchNo: '送货批次号',
  supplierBatchNo: '供应商批次号',
  labels: '标签',
  addLocation: '新增库位',
  editLocation: '编辑库位',
  locationIndex: '库位索引',
  label1: '标签1',
  label2: '标签2',
  label3: '标签3',
  label4: '标签4',
  label5: '标签5',
  locationDescPlaceholder: '请输入库位描述',
  addLocationSuccess: '新增库位成功',
  addLocationFailed: '新增库位失败',
  updateLocationSuccess: '更新库位成功',
  updateLocationFailed: '更新库位失败',
  l1Required: 'L1不能为空',
  l2Required: 'L2不能为空',
  l3Required: 'L3不能为空',
  l4Required: 'L4不能为空',
  l5Required: 'L5不能为空',
  l1RequiredFirst: '请先填写L1',
  l2RequiredFirst: '请先填写L2',
  l3RequiredFirst: '请先填写L3',
  l4RequiredFirst: '请先填写L4',

  // 新增的国际化配置
  location: '库位',
  locationLabel: '库位标签',
  selectLocation: '选择库位',
  searchLocation: '搜索库位',
  locationExist: '该库位已存在',
  editBarcodes: '编辑条码',
  fetchError: '获取数据失败',
  barcodesExceedCount: '条码数量不能超过库位数量',
  checkBarcodes: '请检查条码',
  barcodesExceedNewCount: '条码数量超过新设定的库位数量，请先调整条码',
  barcodesAutoTrimmed: '条码已自动截取',
  barcodesAutoTrimmedDesc: '条码数量超过库位数量，已自动保留前 {{count}} 个条码',
  totalExceedItemCount: '总数量超过限制',
  totalExceedItemCountDesc: '库位总数量 {{current}} 超过订单项数量 {{total}}',
  cannotAddLocation: '无法添加库位',
  totalReachedItemCount: '库位总数量已达到订单项数量 {{total}}',
  inboundSuccess: '入库成功',
  inboundFailed: '入库失败',
  quantityMismatch: '数量不匹配',
  quantityMismatchDesc: '以下商品的库位数量总和与订单数量不一致：',
  currentTotal: '当前总数',
  requiredTotal: '需求数量',
  changeLocation: '更换库位',
  partialInboundSuccess: '部分入库成功',
  removeOldLocationsFailed: '清除旧库位数据失败',
  barcodeCount: '条码个数',
  someItemsInboundFailed: '有商品入库失败',
  inboundResultDetail: '{{success}} 个商品入库成功，{{failed}} 个商品入库失败',
  failedItems: '失败商品',
  noBarcodes: '暂无条码数据',

  outNo: "出库单号",
  innerNo: "内部单号",
  outData: "出库日期",
  outWare: "出货仓库",
  llorg: "领料部门",
  llper: "领料人",
  documentType: "单据类型：",
  outper: "出库员",
  inper: "入库员",
  wareper: "仓管",
  outCheckDate: "审核日期",

  returnRn: "退货原因: ",
  surplus: "正常结余退库",
  defective: "不良品退库",
  refurbished: "不良品加工",
  forceReturn: "是否确认退库？",
  barcodeErr: "条码有误",
  forceInbound: "是否强制入库？",
  forceInboundFailed: "强制入库失败",
  forcedErr: "强制入库失败",
  moveLoc: "移库",
  targetLocation: "目标库位",
  moveCount: "移库数量",
  maxMoveCount: "最大移库数量",
  moveFail: "移库失败",
  moveCurTip: "目标库位不能和当前库位一致",
  pleaseSelectLocation: "请选择库位",
  pleaseInputCount: "请输入数量",
  countExceedMax: "数量超过最大值",
  reoutrecvdpicking: "误出库领料",

  locationIndexExsist: '库位索引：{{index}}已存在',

  // 库位出库
  locationOutbound: "库位出库",
  outNum: "出库数量",
  outBarcodes: "出库条码",
  selectBarcode: "选择条码",
  confirmOutboundTip: "确认出库？",
  confirmOutboundDesc: "确定要对所选批次进行出库操作吗？",
  inventoryMismatch: "库存数据不匹配，请重新核对数据",

  // 条码和扫描单相关
  unsavedData: "有数据未进行保存",
  cancelWithoutSave: "取消后, 数据不可恢复",
  confirmDeleteBarcode: "确定要删除条码吗?",
  deleteCannotRecover: "删除后, 数据不可恢复",
  confirmDeleteScanSheet: "确定要删除扫描单吗?",
  scanSheet: "扫描单",
  completeScanSheetInbound: "完成扫描单, 确定入库",
  barcodesNotInOriginal: "以下条码不存在于原始条码列表中：{{barcodes}}",
  barcodeDuplicateInLocations: "条码{{barcode}}在{{locationCodes}}中重复",

  // 条码生成相关
  validationFailed: "校验失败",
  dataInvalid: "数据不合法, 每个扫描单数据不得超过{{max}}",
  generateFailed: "生成失败",
  maxBarcodeCount: "已达到最大条码数量限制 {{count}} 个",
  batchGenerateBarcodes: "批量生成条形码",
  optional: "可不填",

  // 退库相关
  returnStockModal: "退库",
  orderList: "订单列表",
  leastOneMove: "至少一个批次移库数量大于0",
  confirmPreOut: "确定执行预出库么",
  sign: "签收",
  signed: "已签收",
  signSucc: "签收成功",
  signFail: "签收失败",
  plSignDate: "选择签收日期",
  productRef: "商品推荐",
  selectProduct: "选择商品",
  productExists: "商品已存在",
  addLocationRef: "添加库位商品关联",
  confirmBatchDelete: "确定要批量删除所选的库位商品关联吗？",
  confirmDeleteItem: "确定要删除这条库位商品关联吗？",
  allocatePreOut: "分配预出库",
  allocatePreOutSuccess: "分配预出库成功",
  allocatePreOutFail: "分配预出库失败",

  // 手工入库相关
  manualInbound: "手工入库",
  complete: "完成",
  delete: "删除",
  productCode: "商品编码",
  productName: "商品名称",
  productModel: "商品型号",
  uom: "单位",
  noData: "暂无数据",
  previous: "上一步",
  next: "下一步",
  confirm: "确定",
  notRecommendedLocation: "您选择的库位不是推荐库位",
  isNotRef: "该库位不是推荐库位",
  recommendedLocations: "推荐库位",
  allLocations: "全部库位",
  locationsRequired: "请为每个商品添加库位",
  locationCountRequired: "库位数量不能为空或0",
  inboundComplete: "入库完成",
  inboundSuccessDesc: "入库操作已成功完成",
  otherOut: "其他出库",
  outNumNotZ: "出库数量不可为0",
  outNumExceedStock: "出库数量超出可用库存数量",
  productInput: "录入物料",
  locNumnotOrder: "库位总数量不等于入库数量，请修改",
  outOvernum: "出库数量超出{{num}}个",
  outLossnum: "出库数量缺失{{num}}个",
  outboundLocationError: "以下物料沒有出库库位",
  outboundCountMismatch: "以下物料出库数量不等于要出库的数量，请修改数据",
  noStock: "没有库存",
  delOutTip: "预出库单{{number}}已经生成，是否删除？",
  inputer: "制单人",
  confirmer: "确认人",
  locFailed: "库位信息与订单信息不匹配，请检查",
  reMatchTip: "出库确认失败，需要重新匹配库存",
  reMatchSucc: "库位已重新分配，数据已更新",
  reMatchFail: "重新匹配库存失败",
  delInTip: "预入库单{{number}}已经生成，是否删除？",
  delInSucc: "预入库单{{number}}生成成功",
  inboundUpdateSucc: "预入库单数据已更新",
  delOrderClose: "删除单据",
  notDelClose: "保留单据",
  needPrefit: '预检出现问题，以下出库批次信息需要修正',
  needSucc: '预检成功，出库数据无需修正',
  needFail: '预检失败，获取库存信息失败',
  outPrefit: '出库预检',
  fixOut: '修改出库',
  fixSucc: '出库信息修改成功！',
  fixFail: '出库信息修改失败！',
  outQtyErr: '出库数量分配错误！',
  fetchStockError: '库存获取失败！',
  oldItemInfo: '原出库信息',
  returnInfo: '退库单信息',
  delReturnClose: "退库单{{number}}已经生成，是否删除？",
  confirmReturnTip: "确认退库？",
  returnNumber: "退库单号",
  noUseStock: "没有可用的库存",
  noLotStock: "该退库批次没有库存：{{lot}}",
  noCodeStock: "该物料没有库存：{{code}}",
  returnLot: "退库批次",
  needFix: "确认出库失败，请进行出库预检并修正出库信息或重新分配库存",
  rePreout: "重新分配库存",
  orderCount: "本次出库数量",
  useAmtReq: "需求单所需数量",
  pickingOutbound_m: "材料出库",
  productOldCount: "确认前物料数量",
  productNewCount: "确认后物料数量",
  lotItemOldCount: "确认前批次数量",
  lotItemNewCount: "确认后批次数量",
  noconf: "未确认",
  confed: "已确认",
  plconfed: "是否已确认",
  refNo: "关联单号",
  proIn: "生产入库",
  locProNot: "库存不足：库位：{{locIdx}}，物料{{proCode}}",
  signTime: "签收时间",
  prodTempIn: "生产入库（临时）",

  iqcState: "质检状态",
  notIqc: "未质检",
  iqcEd: "已质检",
  iqcCheck: "IQC质检",
  iqcList: "IQC质检单列表",
  iqcNumber: "质检单号",
  iqcInventory: "出入库单号",
  iqcType: "质检类型",
  iqcUser: "质检员",
  iqcRes: "质检结果",
  iqcTime: "质检时间",
  toQc: "待检",
  qcIng: "检验中",
  passQc: "通过",
  failQc: "不通过",
  front: "外观不良",
  size: "尺寸不良",
  power: "性能不良",
  package: "包装不良",
  tag: "标识不良",
  other: "其他",
  dispReturn: "退货",
  dispAcpt: "让步接收",
  dispRedo: "返工",
  qcInbound: "入库质检",
  qcOutbound: "出库质检",
  qcWarehouse: "在库质检",
  qcProgress: "过程质检",
  qcReturn: "退货质检",
  typePl: "请选择质检类型",
  statePl: "请选择质检状态",
  fetchErr: "质检单获取失败！",
  createdAt: "制单时间",
  creator: "制单人",
  desc: "质检备注",
  qcItems: "质检项",
  checkCount: "质检数量",
  passCount: "合格数量",
  failCount: "不合格数量",
  qcResult: "质检结果",
  defectType: "不良品类型",
  disposition: "处置结果",
  doc: "质检附件",
  remarks: "备注",
  qcItemList: "质检物料列表",
  addQc: "新增QC质检单",
  qcOrder: "质检单",
  selectInventory: "选择出入库单",
  writeQc: "填写质检信息",
  itemCount: "订单数量",
  descPl: "请输入质检备注",
  checkCountPl: "请输入质检数量",
  passCounPl: "请输入合格数量",
  failCountPl: "请输入不合格数量",
  qcResultPl: "请选择质检结果",
  defectTypePl: "请选择不良品类型",
  dispositionPl: "请选择处置结果",
  qcTyePl: "请选择质检类型",
  add: "生成质检单",
  addErr: "生成质检单失败，没有数据",
  addErr1: "生成质检单失败",
  done: "完成",
  doneTip: "质检单{{number}}已生成成功！",
  itemDesc: "请填写质检项备注",
  noUpdate: "没有数据更新，无需保存",
  updateSucc: "保存成功",
  havePass: "已通过",
  notPass: "通过失败！",
  hasUpdata: "有更改未保存，是否保存后再通过？",
  canNotPass: "完成失败",
  canNotPassTip: "请确保所有质检项都有质检结果",
  qcDone: "{{number}}质检完成",
  reQc: "重新质检",
  doneQC: "完成质检",
  optSucc: "操作成功",
  optFail: "操作失败",
  canAddQc: "可以继续添加质检单",
  orderQcDone: "出入库单：{{number}} 质检完成【{{res}}】",
  reQcTip: "确定要重新质检吗？",
  passQcTip: "确定要通过质检吗？",
  failQcTip: "确定要不通过质检吗？",
  normalPrint: "横版分页",
  verticalPrint: "竖版连续",
  manual: "手工",
  production: "生产",
  purchase: "采购",
  sale: "销售",
  dispose: "调拨",
  sourceType: "类型",
  packing: "仓库分拣",
  packingNo: "分拣单号",
  perBoxQuantity: "数量/箱",
  perBoxNetWeight: "净重/箱",
  perBoxGrossWeight: "毛重/箱",
  totalQuantity: "数量",
  totalNetWeight: "净重",
  totalGrossWeight: "毛重",
  measurements: "尺寸",
  packingVolume: "体积",
  draft: "草稿",
  confirmed: "已确认",
  shuted: "已封箱",
  wasted: "已作废",
  packStatus: "分拣状态",
  totalBoxes: "箱数",
  grossWeight: "毛重",
  netWeight: "净重",
  totalVolume: "体积",
  delTip: "你确定作废分拣单：{{no}} 么？",
  addPack: "添加分拣单",
  inventoryPl: "请选择出库单",
  inventoryInPl: "请选择入库单",
  orderPl: "请选择出入库单",
  packDtl: "分拣单详情",
  closeBox: "封箱",
  openBox: "解封",
  killed: "作废",
  confirmSucc: "确认成功",
  confirmFail: "确认失败",
  sealSucc: "封箱成功",
  sealFail: "封箱失败",
  unSealSucc: "解封成功",
  unSealFail: "解封失败",
  wasteFail: "作废失败",
  items: "商品项",
  boxes: "分拣单明细",
  boxNo: "箱号",
  boxBarcode: "箱码",
  lengthMm: "长(cm)",
  widthMm: "宽(cm)",
  heightMm: "高(cm)",
  volumeCbm: "体积(cm³)",
  grossWeightG: "毛重(kg)",
  netWeightG: "净重(kg)",
  packageType: "包装类型",
  marksNumbers: "唛头",
  delBoxTip: "你确定要删：{{no}}么？",
  addBox: "添加箱子",
  editBox: "编辑箱子 {{no}}",
  boxAddItem: "分拣",
  boxedCount: "已分拣数量",
  plItem: "请选择分拣项",
  boxEditItem: "修改分拣信息",
  boxItemQty: "分拣数量",
  declaredUnitPrice: "单价",
  declaredCurrency: "币种",
  hsCode: "HS编码",
  originPlace: "源产地",
  productNameCn: "中文名",
  productNameEn: "英文名",
  brand: "品牌",
  brandType: "品牌类型",
  packingModel: "型号",
  packingOrigin: "产地",
  exportBrandName: "出口品牌名",
  declaredAmount: "总价",
  shutErr: "封箱失败",
  weightNeed: "请填写毛重和净重",
  shipmentOut: "发货出库",
  noShipment: "发货单不存在",
  noOrder: "单据不存在",
  outItems: "出库明细",
  plPreLOcTypes: "请选择出库匹配库位类型",
  shipOutData: "发货出库数据",
  outDone: "出库完成",
  noBox: "没有箱子或箱子为空！",
  needPre: "发货出库单请先分配库存",
  selectSaleOrder: "选择销售单",
  noOutOrder: "没有出库单",
  noOutOrderTip: "没有已确认的出库单",
  outOrderFail: "出库单加载失败",
  selectOutOrder: "选择出库单",
  remainPack: "剩余分拣数量",
  selectLot: "选择批次",
  genShip: "生成发货单",
  searchCode: "搜索料号",
  plSelBox: "请勾选需要发货的箱子",
  plInQuantityLot: "请输入入库数量和lot",
  packOrder: "分拣单",
  toClose: "待封箱",
  gWeightNeed: "请填写毛重",
  addOutOrder: "添加出库单",
  sealAllTip: "分拣单全部箱子都已封箱，单据确认后整单将自动封箱。",
  emptyBox: "空的箱子：{{number}}",
  selectCustomer: "选择客户",
  selectCustomerPl: "请选择客户",
  multiBox: "多箱录入",
  addingTip: "请输入箱子个数（包含当前箱子）",
  addPackQty: "箱数",
  newBoxNumber: "新箱号",
  selBoxErr: "勾选项不合法",
  selBoxErrTip1: "只能勾选已封箱并且未生成过发货单的箱子",
  selBoxErrTip2: "不能勾选空箱子或已经封箱的箱子",
  selBoxErrTip3: "以下箱子已被过滤",
  batchSeal: "批量封箱",
  plBatchSeal: "请勾选要封箱的箱子",
  batchGross: "批量应用毛重（勾选后，将同步更改当前所有箱子的毛重）",
  batchSealSucc: "批量封箱成功",
  batchSealErr: "批量封箱失败",
  editBoxErr: "修改箱子重量失败，箱号：{{number}}",
  sealBoxErr: "封箱失败，箱号：{{number}}",
  filterdSeal: "已封箱的箱子和空箱子已被忽略",
  noSealBox: "没有可以封箱的箱子",
  sealRange: "封箱范围",
  boxNoPl: "请输入箱号",
  reset: "重置",
  startNo: "开始箱号",
  endNo: "结束箱号",
  searchRange: "搜索范围",
  productType: "产品类型",
};

export default warehouse;
